import { takeLatest, takeEvery, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpGet } from 'core/restClient'

const GET_ADDRESS = makeKeys('GET_ADDRESS')

export const getAddress = makeAction(GET_ADDRESS.REQUEST)

const getAddressSuccess = makeAction(GET_ADDRESS.SUCCESS, 'data')

const initial = {
  address: { data: [], loading: false },
}

function* getAddressRequest(action) {
  try {
    const response = yield httpGet('address')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAddressSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getAddressSuccess([]))
  }
}

export function* watchAddressSaga() {
  yield takeLatest(GET_ADDRESS.REQUEST, getAddressRequest)
}

export default createReducer(initial, state => ({
  [GET_ADDRESS.REQUEST]: () => ({
    ...state,
    address: { data: [], loading: true },
  }),
  [GET_ADDRESS.SUCCESS]: (data) => ({
    ...state,
    address: { data: data.data, loading: false },
  })
}))